export const loadFeedAttachableLinkLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-attachablelink" */ './feedAttachableLink');

export const loadFeedGroupAgentSuggestionsLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-groupagentsuggestions" */ './feedGroupAgentSuggestions');

export const loadFeedGroupLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-group" */ './feedGroup');

export const loadFeedGroupTopQuestionsLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-grouptopquestions" */ './feedGroupTopQuestions');

export const loadFeedGroupSimilarQuestionsLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-grouptopquestions" */ './feedGroupSimilarQuestions');

export const loadFeedCampaignLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-campaign" */ './feedCampaign');

export const loadFeedHomeLoadParams = () => import(/* webpackChunkName: "4-feat-feedloadparams-home" */ './feedHome');

export const loadFeedMoreForYouLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-moreforyou" */ './feedMoreForYou');

export const loadFeedInboxLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-inbox" */ './inboxFeed');

export const loadFeedLiveEventLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-liveevent" */ './feedEvent');

export const loadFeedAllStorylineLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-allstoryline" */ './feedAllStoryline');

export const loadFeedDiscoveryStorylineLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-discoverystoryline" */ './feedDiscoveryStoryline');

export const loadFeedFollowedStorylineLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-followedstoryline" */ './feedFollowedStoryline');

export const loadFeedTeamsMeetingLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-teamsmeeting" */ './feedTeamsMeeting');

export const loadFeedUserLoadParams = () => import(/* webpackChunkName: "4-feat-feedloadparams-user" */ './feedUser');

export const loadFeedLeaderEmployeesLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-leaderemployees" */ './feedLeaderEmployees');

export const loadFeedLeaderHighlightedLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-leaderhighlighted" */ './feedLeaderHighlighted');

export const loadFeedInboxDraftLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-inboxdraft" */ './feedInboxDraftThreads');

export const loadFeedInboxScheduledLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-inboxscheduled" */ './feedInboxScheduledThreads');

export const loadFeedBookmarkLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-bookmark" */ './feedBookmark');

export const loadFeedUserWallLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-userwall" */ './feedUserWall');

export const loadFeedNetworkQuestionLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-networkquestion" */ './feedNetworkQuestion');

export const loadFeedNetworkQuestionInboxLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-networkquestioninbox" */ './feedNetworkQuestionInbox');

export const loadFeedDiscoveryNetworkQuestionLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-discoverynetworkquestion" */ './feedDiscoveryNetworkQuestion');

export const loadFeedNetworkThemeLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-networktheme" */ './feedNetworkTheme');

export const loadFeedMyLeadersLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-myleaders" */ './feedMyLeaders');

export const loadFeedPromotedLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-promoted" */ './feedPromoted');

export const loadFeedTopicUnifiedLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-topicunified" */ './feedTopicUnified');

export const loadFeedUserGroupsLoadParams = () =>
  import(/* webpackChunkName: "4-feat-feedloadparams-usergroups" */ './feedUserGroups');
